import { EMPTY_OBJECT } from '../../../../constants/common'

import {
  REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION,
  REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION_TITLE_KEY,
  REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION_VIEW_SETTING_NAME,
  REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION_VISIBILITY_TOOLTIP_KEY,
} from './RequestProfileWidgetDwellersAndLandlords.constants'

function isDwellersAndLandlordsSectionRequestVisible({
  ownerRole,
  sectionId,
  ukConfig,
  visibleToDwellers,
}) {
  const viewSettingName =
    REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION_VIEW_SETTING_NAME[
      sectionId
    ][ownerRole]

  return Boolean(
    visibleToDwellers && viewSettingName && ukConfig?.[viewSettingName]
  )
}

function getRequestProfileWidgetDwellersAndLandlordsSections({
  dwellers,
  landlords,
  ownerRole,
  ukConfig,
  visibleToDwellers,
}) {
  return [
    landlords?.length > 0
      ? {
          id: REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION.landlords,
          items: landlords,
        }
      : null,
    dwellers?.length > 0
      ? {
          id: REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION.dwellers,
          items: dwellers,
        }
      : null,
  ]
    .filter(Boolean)
    .map(section => ({
      ...section,
      isRequestVisible: isDwellersAndLandlordsSectionRequestVisible({
        ownerRole,
        sectionId: section.id,
        ukConfig,
        visibleToDwellers,
      }),
    }))
}

export function getRequestProfileWidgetDwellersAndLandlordsSectionTitle({
  count,
  sectionId,
  t,
}) {
  return t(
    REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION_TITLE_KEY[sectionId],
    {
      count,
    }
  )
}

export function getRequestProfileWidgetDwellersAndLandlordsSectionVisibilityTooltipKey({
  id,
  isRequestVisible,
}) {
  const tooltipKeys =
    REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION_VISIBILITY_TOOLTIP_KEY[
      id
    ]

  return isRequestVisible ? tooltipKeys.visible : tooltipKeys.hidden
}

export function getRequestProfileWidgetDwellersAndLandlordsData(
  requestData = EMPTY_OBJECT,
  ukConfig
) {
  const isVisibleToDwellers = requestData?.visible_to_dwellers

  const sections = getRequestProfileWidgetDwellersAndLandlordsSections({
    dwellers: requestData?.inhabitants?.dwellers,
    landlords: requestData?.inhabitants?.landlords,
    ownerRole: requestData?.owner?.role,
    ukConfig,
    visibleToDwellers: isVisibleToDwellers,
  })

  return {
    isVisibleToDwellers,
    sections,
    shouldRenderWidget: sections.length > 0,
  }
}
